import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Typography, CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import {
  getProcurementDetail,
  updateProcurement,
} from "../../api/biomassProcurement";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../components/Alert";
import CustomAppBar from "../../components/AppBar";
import ProcurementDetailCard from "../../components/Biochar/ProcurementDetailCard";
import { getBiocharPlants } from "../../api/biocharPlant";
import ProcurementPickupForm from "../../components/Biochar/ProcurementPickupForm";

const ProcurementPickupRequest = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [procurement, setProcurement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [biocharPlants, setBiocharPlants] = useState([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    pickup_plant: "",
    pickup_requested_on: dayjs(),
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    console.log("e", e);
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const fetchProcurementDetails = async () => {
    try {
      const response = await getProcurementDetail(id);
      console.log("Procurement details:", response);
      setProcurement(response);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching procurement details:", error);
      showAlert("error", "Failed to fetch procurement details");
      setLoading(false);
    }
  };

  const fetchBiocharPlants = async () => {
    try {
      const response = await getBiocharPlants();
      setBiocharPlants(response || []);
    } catch (error) {
      console.error("Error fetching Biochar plants", error);
      showAlert("error", "Failed to fetch Biochar plants");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!formData.pickup_plant) {
      errors.pickup_plant = "Inward plant is required";
    }
    if (!formData.pickup_requested_on) {
      errors.pickup_requested_on = "Pickup requested on is required";
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    try {
      let request_data = {
        pickup_plant: formData.pickup_plant,
        pickup_requested_on: dayjs(formData.pickup_requested_on).format(),
        status: "PICKUP_REQUESTED",
      };
      let response = await updateProcurement(id, request_data);
      console.log("Pickup requested successfully:", response.data);
      showAlert("success", "Pickup requested successfully");
      navigate("/procurement-list");
    } catch (error) {
      console.error("Error requesting pickup:", error);
      showAlert("error", "Failed to request pickup");
    }
  };

  useEffect(() => {
    fetchProcurementDetails();
    fetchBiocharPlants();
  }, []);

  return (
    <>
      <CustomAppBar />
      {loading ? (
        <CircularProgress />
      ) : procurement ? (
        <>
          <ProcurementDetailCard procurement={procurement} />
          <ProcurementPickupForm
            formData={formData}
            errors={errors}
            onChange={(e) => handleChange(e)}
            onSubmit={handleSubmit}
            biocharPlants={biocharPlants}
          />
        </>
      ) : (
        <Typography variant="h6">{t("Procurement not found")}</Typography>
      )}
    </>
  );
};

export default ProcurementPickupRequest;
